var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStethoscope = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,6c0.56,0 1,0.43 1,1c0,0.55228 -0.44772,1 -1,1c-0.57,0 -1,-0.45 -1,-1c0,-0.57 0.43,-1 1,-1zM0,0v9c0,2.96 2.19,5.5 5.14,5.91c0.62,3.01 3.28,5.09 6.36,5.09c3.58985,0 6.5,-2.91015 6.5,-6.5v-3.69c1.16,-0.42 2,-1.52 2,-2.81c0,-1.65685 -1.34315,-3 -3,-3c-1.65685,0 -3,1.34315 -3,3c0,1.29 0.84,2.4 2,2.81v3.6c0,2.5 -2,4.5 -4.5,4.5c-2,0 -3.68,-1.21 -4.28,-3.01c2.78,-0.6 4.78,-3.1 4.78,-5.9v-9h-4v3h2v6c0,2.20914 -1.79086,4 -4,4c-2.20914,0 -4,-1.79086 -4,-4v-6h2v-3z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(99, 115, 129)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1720479628145132309",
    d: "M17,6c0.56,0 1,0.43 1,1c0,0.55228 -0.44772,1 -1,1c-0.57,0 -1,-0.45 -1,-1c0,-0.57 0.43,-1 1,-1zM0,0v9c0,2.96 2.19,5.5 5.14,5.91c0.62,3.01 3.28,5.09 6.36,5.09c3.58985,0 6.5,-2.91015 6.5,-6.5v-3.69c1.16,-0.42 2,-1.52 2,-2.81c0,-1.65685 -1.34315,-3 -3,-3c-1.65685,0 -3,1.34315 -3,3c0,1.29 0.84,2.4 2,2.81v3.6c0,2.5 -2,4.5 -4.5,4.5c-2,0 -3.68,-1.21 -4.28,-3.01c2.78,-0.6 4.78,-3.1 4.78,-5.9v-9h-4v3h2v6c0,2.20914 -1.79086,4 -4,4c-2.20914,0 -4,-1.79086 -4,-4v-6h2v-3z",
    vectorEffect: "non-scaling-stroke"
  })))));
};
export default SvgStethoscope;